import type { CalendarEventData } from '@shared/core/add-to-calendar'
import { generateICSFile } from '@shared/core/add-to-calendar'

export function downloadICSFile(data: CalendarEventData, filename?: string): void {
  const icsContent = generateICSFile(data)
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename || `appointment-${data.startTime.toISOString().split('T')[0]}.ics`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}
